<template>
  <div class="con">
    <div class="con-left">
      <ul v-for="item in menulist" :key="item.chID">
        <li
          :class="{ active: item.chID === acctiveId }"
          @click="addClass(item)"
        >
          {{ item.chName }}
        </li>
      </ul>
    </div>
    <div v-if="getCurrentList" class="con-right">
      <div class="con-select">
        <i
          class="sub-select"
          :class="{ active: items.coID === coID }"
          v-for="items in getCurrentList"
          :key="items.coID"
          @click="changeCoId(items.coID)"
          >{{ items.coName }}</i
        >
      </div>
      <div class="test-list">
        <TestItem :testsItem="testsItem" />
      </div>
    </div>
  </div>
  <div class="pagination">
    <el-pagination
      v-model:current-page="currentPage"
      v-model:page-size="pageSize"
      @size-change="changeSize"
      @current-change="currentChange"
      :current-page="currentPage"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pageSize"
      background
      layout="total,  prev, pager, next"
      :total="testsCount"
    >
    </el-pagination>
  </div>
</template>

<script>
import { useStore } from "vuex";

import { findTestsItem } from "@/api/tests";
import { useRouter, useRoute } from "vue-router";
import { computed, watch, ref, nextTick } from "vue";
import TestItem from "./test-item.vue";

export default {
  name: "testSelect",
  components: {
    TestItem,
  },

  // eslint-disable-next-line vue/no-setup-props-destructure
  setup(props, { emit }) {
    //总页数
    const testsCount = ref(0);
    //当前页码
    const currentPage = ref(1);
    //每页数
    const pageSize = ref(20);

    const target = ref(null);
    const route = useRoute();
    const router = useRouter();
    const store = useStore();

    const acctiveId = ref(206);
    const addClass = (item) => {
      try {
        acctiveId.value = item.chID;
        coID.value = item.chID;
      } catch (error) {
        console.log(error);
      }
    };
    const coID = ref(206);
    const changeCoId = (id) => {
      try {
        coID.value = id;
      } catch (error) {
        console.log(error);
      }
    };
    const maID = computed(() => {
      console.log(route.query.maID);
      return route.query.maID;
    });

    //获取题库商品列表
    const testsItem = ref([]);

    //切换不同选项加载不同数据
    watch([maID, coID, acctiveId], (newValue, oldValue) => {
      findTestsItem({
        maID: route.query.maID,
        chID: acctiveId.value,
        coID: coID.value,
        size: pageSize.value,
        page: currentPage.value,
      })
        .then((data) => {
          testsItem.value = [];
          nextTick(() => {
            testsCount.value = data.resultLength[0]?.totalCount;
            testsItem.value = data.result.map((item) => {
              return {
                chID: item.chID,
                maID: item.maID,
                coID: item.coID,
                clID: item.clID,
                grade: item.grade.find((ele) => ele._id == item.gradeID),
                testsName: item.testsName,
                id: item._id,
                testsCoverImg: item.testsCoverImg,
              };
            });
          });
        })
        .catch((error) => {
          console.log(error);
        });
    });

    //题库数据懒加载
    findTestsItem({
      maID: route.query.maID,
      chID: acctiveId.value,
      coID: coID.value,
      size: pageSize.value,
      page: currentPage.value,
    })
      .then((data) => {
        testsItem.value = [];
        nextTick(() => {
          testsCount.value = data.resultLength[0]?.totalCount;
          testsItem.value = data.result.map((item) => {
            return {
              chID: item.chID,
              maID: item.maID,
              coID: item.coID,
              clID: item.clID,
              grade: item.grade.find((ele) => ele._id == item.gradeID),
              testsName: item.testsName,
              id: item._id,
              testsCoverImg: item.testsCoverImg,
            };
          });
        });
      })
      .catch((error) => {
        console.log(error);
      });

    const menulist = computed(() => {
      return store.state.category.list?.filter((item) => {
        return item.pid == 0 && item.id == 1;
      });
    });

    const getCurrentList = computed(() => {
      return store.state.category.list?.filter((item) => {
        return item.caID === acctiveId.value;
      });
    });
    const currentChange = (page) => {
      try {
        currentPage.value = page;
      } catch (error) {
        console.log(error);
      }
    };
    const changeSize = (size) => {
      try {
        pageSize.value = size;
      } catch (error) {
        console.log(error);
      }
    };
    return {
      menulist,
      getCurrentList,
      changeCoId,
      addClass,
      acctiveId,
      coID,
      testsItem,
      target,
      currentChange,
      changeSize,
      pageSize,
      testsCount,
      currentPage,
    };
  },
};
</script>

<style lang="less" scoped>
.con {
  display: flex;
  margin-top: 15px;
  .con-left {
    width: 200px;
    height: 600px;
    //height: 1070px;
    background: rgb(245, 245, 245);
    ul {
      li {
        display: block;
        height: 60px;
        line-height: 60px;
        text-align: center;
        font-size: 20px;
        border: 1px solid #fcfcfc;
        &:hover {
          cursor: pointer;
          color: @shColor;
        }
        &.active {
          cursor: pointer;
          background: #fff;
          color: @shColor;
        }
      }
    }
  }
  .con-right {
    width: 1090px;
    //height: 50px;
    .con-select {
      display: flex;
      flex-wrap: wrap;
      margin-left: 7px;
      .sub-select {
        display: block;

        //width: 85px;
        padding-left: 10px;
        padding-right: 10px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        font-size: 17px;
        margin: 5px 5px 5px 5px;

        background-color: rgb(245, 245, 245);
        border-radius: 5px;
      }
      & :hover {
        color: @shColor;
        cursor: pointer;
      }
      & .active {
        color: @shColor;
      }
    }
    .test-list {
      display: flex;
      flex-wrap: wrap;
      //margin-left: 7px;
      margin-top: 10px;
      width: 100%;
      //height: 610px;
      .tests-item {
        margin-right: 6.5px;
        margin-bottom: 10px;
        background: #efefef;
        width: 255px;
        height: 300px;
        position: relative;
        overflow: hidden;
        border: 1px solid transparent;
        transition: all 0.5s;
        &:nth-child(4n) {
          margin-right: 0px;
        }
        &:nth-last-child(-n + 4) {
          margin-bottom: 0;
        }
        .grade {
          position: absolute;
          font-weight: bold;
          top: 46.67%;
          left: 36.37%;
        }
        .grade1 {
          position: absolute;
          font-weight: bold;
          top: 46.67%;
          left: 31.37%;
        }
        .image {
          display: block;
          width: 255px;
          height: 190px;
          margin: 0 auto;
          img {
            width: 100%;
            height: 100%;
          }
        }
        p {
          margin: 6px 5px 10px 5px;
          height: 45px;
          font-size: 16px;
        }
        .old-price {
          padding-left: 8px;
          color: @priceColor;
          font-size: 16px;
          height: 16px;
          text-decoration: line-through;
        }
        .price {
          margin-left: 8px;
          color: @priceColor;
          font-size: 16px;
          height: 16px;
        }

        &:hover {
          border-color: @shColor;
        }
      }
    }
  }
}
.pagination {
  /* margin-top: 20px;
  margin-bottom: 20px; */
  display: flex;
  justify-content: center;
}
</style>
